import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RequestStatus } from '@patient-ui/shared/enums';

import {
  PatientEstimateState,
  patientEstimateFeatureKey,
} from './patient-estimate.reducer';

export const patientEstimateStateSelector =
  createFeatureSelector<PatientEstimateState>(patientEstimateFeatureKey);

export const patientEstimateVerifyResponseSelector = createSelector(
  patientEstimateStateSelector,
  (state: PatientEstimateState) => state.verifyResponse
);

export const patientEstimateVerifyStatusSelector = createSelector(
  patientEstimateStateSelector,
  (state: PatientEstimateState) => state.verifyRequestStatus
);

export const patientEstimateVerifyErrorSelector = createSelector(
  patientEstimateStateSelector,
  (state: PatientEstimateState) => state.verifyRequestError
);

export const patientEstimateErrorCodeSelector = createSelector(
  patientEstimateStateSelector,
  (state: PatientEstimateState) => state.errorCode
);

export const patientEstimateIsPendingSelector = createSelector(
  patientEstimateStateSelector,
  (state: PatientEstimateState) =>
    state.verifyRequestStatus === RequestStatus.Pending
);

export const patientEstimateIsSuccessSelector = createSelector(
  patientEstimateStateSelector,
  (state: PatientEstimateState) =>
    state.verifyRequestStatus === RequestStatus.Success
);

export const patientEstimateIsFailureSelector = createSelector(
  patientEstimateStateSelector,
  (state: PatientEstimateState) =>
    state.verifyRequestStatus === RequestStatus.Failure
);
